import Icon from "icons"
import styled from "styled-components"
import { eq, when, minWidth, maxWidth } from "utils"
import { Button } from "components/button/cta/styles"

export const PurchaseForm = styled.div`
  * {
    line-height: 1.35;
  }

  ${({ theme }) =>
    !theme.component.isNested &&
    `
      margin: 0 auto;
      padding: 8rem 0;
      padding-left: calc((100% - 74rem) / 2);
      padding-right: calc((100% - 74rem) / 2);
    `}

  ${maxWidth.mobile`
    padding: 2.5rem;
  `}
`

export const PaymentTypes = styled.div`
  display: flex;
  margin-top: 0;
  flex-direction: column;
  align-items: flex-start;
  justify-content: left;
  width: 100%;
  align-items: stretch;
  border-bottom: #d0d0d0 1px solid;
  padding: 0 0 2.2rem;

  ${minWidth.tablet`
    flex-direction: row;
  `}

  ${minWidth.hamburgerLarge`
    flex-direction: column;
  `}

  ${minWidth.rightRail`
    flex-direction: row;
  `}
`

export const PaymentType = styled.span`
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: space-between;
  min-width: 230px;
  margin-top: 1.6rem;
  font-size: 1.5rem;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 500;
  letter-spacing: normal;
  padding: 1rem 1.4rem 1rem 1.8rem;
  height: auto;
  background-color: ${({ theme }) => theme.component.background};
  border-radius: 6px;
  border: solid 3px #ffffff;
  box-shadow: 0 1px 7px 0 rgba(145, 145, 145, 0.35);
  cursor: pointer;
  color: ${({ theme }) => theme.component.text};

  &:first-child {
    margin-right: 0;

    ${minWidth.mobile`
      margin-right: 1.5rem;
    `}

    ${minWidth.hamburgerLarge`
      margin-right: 0;
    `}

    ${minWidth.rightRail`
      margin-right: 1.5rem;
    `}
  }

  ${when("active")`
    border-color: ${({ theme }) => theme.component.cta};
    background-color: #ffffff;
    ${({ theme }) =>
      theme.component.isDarkBackground &&
      `
      color: ${theme.colors.text.primary};
      border-color: #fff;
    `}
  `}
`

export const PaymentTypeName = styled.span`
  padding-right: 1rem;
`

export const PaymentTypePrice = styled.span`
  border-left: solid 1px #222222;
  padding-left: 0.8rem;
`

export const CartOptions = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 2.1rem;
  color: ${({ theme }) => theme.component.text};

  ${when("subscriptionDisabled")`
    border-top: #d0d0d0 1px solid;
  `}
`

export const DeliveryInterval = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: center;
  padding: 0 0 2.2rem;
  font-size: 1.8rem;
  border-bottom: solid 1px #d0d0d0;

  > * {
    margin-right: 8px;
    padding-top: 2.2rem;
  }
`

export const DeliveryIntervalSpan = styled.span``

export const QuantitySelectWrapper = styled.div`
  max-width: 50%;
  margin-bottom: 0;
  position: relative;
`

export const QuantitySelect = styled.select`
  background-color: #fff;
  transition: none;
  text-transform: capitalize;
  margin-bottom: 0;
  min-width: 8rem;
  max-width: 300px;
  border: 1px solid #c8c8c8;
  border-radius: 30px;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 500;
  font-size: 1.4rem;
  height: 4rem;
  padding: 0 4.5rem 0 1.8rem;
  text-align: left;
  transition: border 0.3s ease-in-out;
  width: 100%;
  appearance: none;
`

export const QuantitySelectDownArrow = styled(Icon)`
  height: 1.2rem;
  position: absolute;
  right: 2.5rem;
  top: 66%;
  transform: translateY(-50%) rotate(90deg);
  width: 1.2rem;
  pointer-events: none;

  g {
    fill: ${({ theme }) => theme.colors.text.primary};
  }
`

export const IntervalOptions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-right: 0.4rem;
`

export const IntervalOption = styled.div`
  padding: 0.6rem 0;
  min-width: 9rem;
  max-height: 36rem;
  margin-right: 0.8rem;
  border-radius: 0.6rem;
  box-shadow: 0 1px 7px 0 rgba(145, 145, 145, 0.35);
  border: solid 3px #fff;
  background-color: ${({ theme }) => theme.component.background};
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 500;
  font-size: 1.6rem;
  cursor: pointer;
  text-align: center;
  color: ${({ theme }) => theme.component.text};

  ${maxWidth.mobile`
    margin-bottom: 0.8rem;
  `}

  ${when("active")`
    border-color: ${({ theme }) => theme.component.cta};
    background-color: #fff;
    ${({ theme }) =>
      theme.component.isDarkBackground &&
      `
      color: ${theme.colors.text.primary};
      border-color: #fff;
    `}
  `}
`

export const StaticInterval = styled.span``

export const ProductServings = styled.div`
  font-size: 1.4rem;
  width: 100%;
`

export const AddToCart = styled.div``

export const AddToCartButton = styled(Button)`
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 500;
  font-size: 1.5rem;
  letter-spacing: normal;
  padding: 1.2rem 4.2rem;
  height: auto;
  min-width: 1.3rem;

  ${maxWidth.hamburgerLarge`
    width: 100%;
  `}
`

export const Notes = styled.div`
  color: #999;
  font-size: 1.6rem;
  margin-top: 2.4rem;
  ${({ theme }) =>
    theme.component.isDarkBackground &&
    `
      color: ${theme.component.text};
    `}
`

export const TooltipContainer = styled.div`
  display: none;
  width: 34.6rem;
  left: -21.5rem;
  top: 3.6rem;
  position: absolute;
  padding: 2rem 3rem;
  font-size: 1.5rem;
  z-index: 800;
  border-radius: 0.6rem;
  box-shadow: 0 1px 25px 0 rgba(145, 145, 145, 0.35);
  background-color: white;
  ${({ theme }) =>
    theme.component.isDarkBackground &&
    `
      color: ${theme.colors.text.primary};
    `}

  ${maxWidth.mobile`
    width: 26rem;
  `}

  @media (max-width: 581px) {
    left: 0;
  }

  ${eq("type", "refund")`
    @media (min-width: 451px) and (max-width: 482px) {
      left: -10rem;
    }
    @media (min-width: 582px) and (max-width: 1024px) {
      left: -10rem;
    }
  `}

  ${eq("type", "shipping")`
    @media (min-width: 393px) and (max-width: 450px) {
      left: -18rem;
    }
    @media (min-width: 582px) and (max-width: 767px) {
      left: -25rem;
    }
  `}
`

export const TooltipIconContainer = styled.div`
  position: relative;
`

export const TooltipTopArrow = styled.div`
  display: none;
  position: absolute;
  top: 2.2rem;
  left: 2.6rem;
  z-index: 801;
  width: 0;
  height: 0;
  border-left: 1.5rem solid transparent;
  border-right: 1.5rem solid transparent;
  border-bottom: 1.5rem solid white;
`

export const Tooltip = styled.div`
  cursor: pointer;
  position: relative;
  display: inline-block;
  padding: 0;
  text-decoration: underline;

  &:hover {
    ${TooltipContainer} {
      display: block;
    }

    ${TooltipTopArrow} {
      display: block;
    }
  }
`

export const TooltipTitle = styled.div`
  color: #7d7d7d;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 500;
  margin-bottom: 0.5rem;
`

export const TooltipBody = styled.div`
  ul {
    list-style-position: outside;
    margin: 0;
    padding-left: 1.7rem;
  }

  ${TooltipTitle} {
    padding-top: 1rem;
  }
`
